<template>
	<v-card>
		<v-card-title>
			<h2>Kody DAC</h2> 
			<v-spacer></v-spacer>
		</v-card-title>
		<div>
			<v-flex xs5>
				<v-layout wrap>
							<v-flex xs9>
								<v-subheader>{{isDacCodeEnabled ?
									"Kody DAC" :
									"Brak kodów DAC"}}
								</v-subheader>
							</v-flex>
							<v-flex xs3>
								<v-switch aria-label="label for switch"
									v-model="isDacCodeEnabled"
									@change="updateStatus"
								></v-switch>
							</v-flex>
				</v-layout>
			</v-flex>
		</div>
		<div v-if="isDacCodeEnabled">
			<div>
			<v-btn
				v-if="!contestData.announced"
				color="primary" dark class="ml-3 mt-4" @click="addCodeDialog = true">Dodaj kod
			</v-btn>
		</div>
		<div>
			<v-btn
				v-if="!contestData.announced"
				color="primary" dark class="ml-3" @click="copyCodes">Zaimportuj wszystkie kody
			</v-btn>
		</div>
		<egranty-table
			:items="codes"
			:headers="headers"
			export-sorted-by-field-name="code"
			:row-actions="actions"
			:row-actions-visible="!contestData.announced"
			:table-name="'Kody DAC w tym konkursie'"
			@delete="removeCode"
		></egranty-table>
		</div>

		<v-dialog v-model='addCodeDialog' persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Dodaj kod DAC</span>
				</v-card-title>
				<v-card-text>
					<v-layout row>
						<v-autocomplete
							label="Kod"
							:items="codesToAdd"
							item-text="viewData"
							item-value="id"
							aria-label="code"
							v-model="codeToAddId"
							:menu-props="{
								maxWidth: '940px',
								'contentClass': 'contest-dac-codes-autocomplete'
							}">
						</v-autocomplete>
					</v-layout>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn v-if="codeToAddId !== null"
						color="primary"
						@click="addCode">
						Zapisz
					</v-btn>
					<v-btn
						color="blue"
						@click="addCodeDialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import EgrantyTable from "../../../../genericComponents/EgrantyTable";
	import {PublicContest} from "@/api/generated/PublicContest";

	export default {
		name: "DACCodes",
		components: {EgrantyTable},

		data () {
			return {
				codes: [],
				codesToAdd: [],
				addCodeDialog: false,
				codeToAddId: null,
				headers: [
					{text: "Kod", value: "code"},
					{text: "Opis", value: "description"}
				],
				actions: [
					{name: "delete", icon: "delete"}
				],
				contestData: {
					announced: undefined
				},
				isDacCodeEnabled: true,
			};
		},

		watch: {
			addCodeDialog (val) {
				if (!val) this.codeToAddId = null;
			},
		},

		methods: {
			removeEmptyTableLoading () {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},
			update () {
				PublicContest.getDacCodes(this, this.$route.params.id, successResponse => {
						this.codes = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy kodów DAC", errorResponse);
					});

				PublicContest.getDacCodesAvailableToAdd(this, this.$route.params.id, successResponse => {
						this.codesToAdd = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy kodów DAC", errorResponse);
					});
			},

			copyCodes () {
				this.$confirm("Czy na pewno chcesz zaimportować wszystkie kody?", {
					title: 'Uwaga',
					color: 'blue',
					width: 500
				})
					.then(response => {
						if (response) {
							PublicContest.postDacCodes(this, this.$route.params.id, successResponse => {
									this.$messagesBus.$emit("success", "Kody zostały pomyślnie zaimportowane", successResponse);
									this.update();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się zaimportować kodów", errorResponse);
								});
						}
					});
			},

			updateStatus () {
				PublicContest.putDacCodesStatus(this, this.$route.params.id, this.isDacCodeEnabled, successResponse => {
						this.$messagesBus.$emit("success", "Zaktualizowano status kodów DAC", successResponse);
						this.getStatus();		
					},
					errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
						this.getStatus();
					});
			},

			getStatus () {
				PublicContest.getDacCodesStatus(this, this.$route.params.id, successResponse => {
						this.isDacCodeEnabled = successResponse;
						if(this.isDacCodeEnabled) this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu kodów DAC", errorResponse);
					});
			},

			addCode () {
				PublicContest.putDacCodes(this, this.$route.params.id, this.codeToAddId, successResponse => {
						this.addCodeDialog = false;
						this.$messagesBus.$emit("success", "Kod został pomyślnie dodany", successResponse);
						this.update();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się dodać kodu", errorResponse);
					});
			},

			removeCode (item) {
				this.$confirm("Czy na pewno chcesz usunąć kod?", {
					icon: 'delete',
					title: 'Uwaga',
					color: "lightred",
					width: 500
				})
					.then(response => {
						if (response) {
							if(this.announced && this.codes && this.codes.length == 1){
								this.$messagesBus.$emit("error", "Nie można usunąć osatniego kodu DAC, gdy konkurs został już opublikowany.");
								return;
							}
							PublicContest.deleteDacCodes(this, item.id, successResponse => {
									this.$messagesBus.$emit("success", "Kod został pomyślnie usunięty", successResponse);
									this.update();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
								});
						}
					});
			}
		},

		mounted () {
			this.getStatus();
			if(this.isDacCodeEnabled) {
				this.removeEmptyTableLoading();
			}
		},

		props: {
			announced: undefined
		}
	};
</script>

<style scoped>
	.theme--dark .white {
		background-color: #767676 !important;
		color: #fff !important;
	}
  contest-dac-codes-autocomplete .v-list__tile__title {
    text-overflow: unset;
    height: auto;
    overflow: auto;
    white-space: normal;
  }
</style>
